import { Injectable } from '@angular/core';
import { DocumentTypeServiceFactory, FilterLabel, IDocumentType } from 'document-type-picker-lib';
import { Namespace } from 'enums-lib';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DocumentTypeService {

  constructor(
    private documentTypeServiceProvider: DocumentTypeServiceFactory) {
  }

  getDocumentTypes(namespace: string | Namespace, entityTypes: string[], filterLabel?: FilterLabel) {
    const documentTypeService = this.documentTypeServiceProvider.getService(namespace);
    const entityTypesObs = entityTypes.map(entityType => documentTypeService.getDocumentTypes(entityType, filterLabel));
    return forkJoin(entityTypesObs).pipe(
      map(value => this.removeDuplicates(value.flat()))
    );
  }

  private removeDuplicates(array: IDocumentType[] ): IDocumentType[] {
    return array.filter((value, index, self) =>
      index === self.findIndex((item) => item.id === value.id)
    );
  }
}
